import { ICSSInJSStyle } from "@fluentui/react-northstar";
import { CSSProperties } from "react";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

interface AudioMicButtonStyles {
  circleIcon: CSSProperties;
  micIconCircleGray: CSSProperties;
  micIconCirclePurple: CSSProperties;
  micIconShadow: CSSProperties;
  audioProgressCircle: CSSProperties;
  micButton: ICSSInJSStyle;
  middleSectionDefault: ICSSInJSStyle;
  middleSectionGlow: ICSSInJSStyle;
}

export const useAudioMicButtonStyles: () => AudioMicButtonStyles = () => {
  const { brand } = useFluentColorScheme();
  const { isMobile } = usePlatformTypeContext();

  if (isMobile) {
    return {
      circleIcon: {
        cursor: "pointer",
        position: "absolute",
        height: "120px",
        width: "120px",
        left: "calc(50% - 60px)",
        top: "calc(50% -10px)",
      },
      micIconCircleGray: {
        width: "100px",
        height: "100px",
        fill: "#404040",
        position: "absolute",
        left: "calc(50% - 50px)",
        top: "calc(50%)",
      },
      micIconCirclePurple: {
        width: "100px",
        height: "100px",
        fill: "#6264A7",
        position: "absolute",
        left: "calc(50% - 50px)",
        top: "calc(50% )",
      },
      micIconShadow: {
        position: "absolute",
        width: "114px",
        height: "114px",
        fill: "transparent",
        stroke: "rgba(255, 255, 255, 0.36)",
        strokeWidth: "4px",
        left: "calc(50% - 57px)",
        top: "calc(50%)",
        filter:
          "drop-shadow(0px 4.8px 14.4px rgba(0, 0, 0, 0.14)) drop-shadow(0px 25.6px 57.6px rgba(0, 0, 0, 0.12))",
      },
      audioProgressCircle: {
        position: "absolute",
        fill: "transparent",
        strokeDasharray: "0 500",
        strokeWidth: "4px",
        borderRadius: "100%",
        stroke: "#9EA2FF",
      },
      micButton: {
        height: "100px",
        width: "100px",
        left: "calc(50% - 60px)",
        top: "calc(50% )",
        margin: "10px",
        backgroundColor: brand.background,
        position: "absolute",
        border: "none",
      },
      middleSectionDefault: {
        backgroundColor: "transparent",
        height: "200px",
        width: "200px",
        left: "calc(50% - 100px)",
        top: "calc(50% - 60px)",
        position: "absolute",
      },
      middleSectionGlow: {
        height: "200px",
        width: "200px",
        left: "calc(50% - 100px)",
        top: "calc(50% - 50px)",
        backgroundColor: brand.background,
        backgroundBlendMode: "soft-light",
        opacity: "1",
        border: "8px solid #9EA2FF",
        backdropFilter: "blur(75px)",
        filter: "blur(75px)",
        transition: "background-color 3s ease",
        position: "absolute",
      },
    };
  } else {
    return {
      circleIcon: {
        cursor: "pointer",
        position: "absolute",
        height: "120px",
        width: "120px",
        left: "calc(380px - 60px)",
        top: "calc(348px - 60px)",
      },
      micIconCircleGray: {
        width: "100px",
        height: "100px",
        fill: "#404040",
        left: "calc(380px - 50px)",
        top: "calc(348px - 50px)",
      },
      micIconCirclePurple: {
        width: "100px",
        height: "100px",
        fill: "#6264A7",
        left: "calc(380px - 50px)",
        top: "calc(348px - 50px)",
      },
      micIconShadow: {
        position: "absolute",
        width: "114px",
        height: "114px",
        fill: "transparent",
        stroke: "rgba(255, 255, 255, 0.36)",
        strokeWidth: "4px",
        left: "calc(380px - 57px)",
        top: "calc(348px - 57px)",
        filter:
          "drop-shadow(0px 4.8px 14.4px rgba(0, 0, 0, 0.14)) drop-shadow(0px 25.6px 57.6px rgba(0, 0, 0, 0.12))",
      },
      audioProgressCircle: {
        position: "absolute",
        fill: "transparent",
        strokeDasharray: "0 500",
        strokeWidth: "4px",
        borderRadius: "100%",
        stroke: "#9EA2FF",
      },
      micButton: {
        height: "100px",
        width: "100px",
        left: "calc(380px - 60px)",
        top: "calc(348px - 60px)",
        margin: "10px",
        backgroundColor: brand.background,
        position: "absolute",
        border: "none",
      },
      middleSectionDefault: {
        backgroundColor: "transparent",
        height: "200px",
        width: "200px",
        left: "calc(380px - 100px)",
        top: "calc(348px - 100px)",
        position: "absolute",
      },
      middleSectionGlow: {
        height: "200px",
        width: "200px",
        left: "calc(380px - 100px)",
        top: "calc(348px - 100px)",
        backgroundColor: brand.background,
        backgroundBlendMode: "soft-light",
        opacity: "1",
        border: "8px solid #9EA2FF",
        backdropFilter: "blur(75px)",
        filter: "blur(75px)",
        transition: "background-color 3s ease",
        position: "absolute",
      },
    };
  }
};
